/** Canonical workout-style definitions used across the app */

export interface WorkoutStyleConfig {
  id: string;
  label: string;
  shortLabel: string;
  color: string; // tailwind bg class using design tokens
  emoji: string;
  /** Muscle groups to prioritize in exercise pickers */
  recommendedMuscles?: string[];
  /** Equipment to prioritize */
  recommendedEquipment?: string[];
}

export const WORKOUT_STYLES: WorkoutStyleConfig[] = [
  { id: "strength_general", label: "Strength", shortLabel: "STR", color: "bg-primary/15 text-primary", emoji: "💪", recommendedMuscles: ["Chest", "Back", "Shoulders", "Quads", "Hamstrings", "Glutes"], recommendedEquipment: ["Barbell", "Dumbbell"] },
  { id: "bodybuilding", label: "Bodybuilding", shortLabel: "BB", color: "bg-accent text-accent-foreground", emoji: "🏋️", recommendedMuscles: ["Chest", "Back", "Shoulders", "Biceps", "Triceps", "Quads", "Hamstrings", "Glutes", "Calves"], recommendedEquipment: ["Dumbbell", "Cable", "Machine"] },
  { id: "hiit", label: "HIIT", shortLabel: "HIIT", color: "bg-destructive/15 text-destructive", emoji: "🔥", recommendedMuscles: ["Full Body", "Cardio", "Core"], recommendedEquipment: ["Bodyweight", "Kettlebell", "Barbell"] },
  { id: "mobility_recovery", label: "Mobility & Recovery", shortLabel: "MOB", color: "bg-muted text-muted-foreground", emoji: "🧘‍♂️", recommendedMuscles: ["Core", "Glutes", "Hamstrings", "Shoulders"], recommendedEquipment: ["Bodyweight", "Band"] },
  { id: "yoga", label: "Yoga", shortLabel: "YOGA", color: "bg-success/15 text-[hsl(var(--success))]", emoji: "🧘", recommendedMuscles: ["Core", "Full Body"], recommendedEquipment: ["Bodyweight"] },
  { id: "pilates", label: "Pilates", shortLabel: "PIL", color: "bg-secondary text-secondary-foreground", emoji: "🤸", recommendedMuscles: ["Core", "Glutes"], recommendedEquipment: ["Bodyweight", "Band"] },
  { id: "endurance_running", label: "Running", shortLabel: "RUN", color: "bg-primary/10 text-primary", emoji: "🏃", recommendedMuscles: ["Cardio", "Quads", "Hamstrings", "Calves", "Core"], recommendedEquipment: ["Machine", "Bodyweight"] },
  { id: "endurance_cycling", label: "Cycling", shortLabel: "CYC", color: "bg-accent text-accent-foreground", emoji: "🚴", recommendedMuscles: ["Cardio", "Quads", "Hamstrings", "Glutes", "Core"], recommendedEquipment: ["Machine"] },
];

export const STYLE_MAP = new Map(WORKOUT_STYLES.map((s) => [s.id, s]));

export function getStyleConfig(id: string | null | undefined): WorkoutStyleConfig {
  return STYLE_MAP.get(id ?? "") ?? WORKOUT_STYLES[0];
}

export const GYM_CATEGORIES = [
  { id: "standard_gym", label: "Standard Gym" },
  { id: "studio", label: "Studio" },
  { id: "box", label: "Box / HIIT Gym" },
  { id: "other", label: "Other" },
] as const;
